/**
 * RouteService 实现
 *
 * 封装 react-router 的核心能力，实现 IRouteService 接口。
 * 业务模块通过 DI 获取此服务，无需直接依赖 react-router。
 *
 * 此服务是 react-router 的代理层，所有实现细节由 react-router 提供。
 */
import { Link, useParams, useNavigate, useLocation, useSearchParams } from 'react-router';
/**
 * 路由服务实现类
 *
 * 封装 react-router 的 Link、useParams、useNavigate、useLocation、useSearchParams，
 * 业务模块通过 DI 获取此服务实例，实现路由能力的解耦。
 */
export class RouteService {
    /** Link 组件（直接代理到 react-router） */
    Link = Link;
    /** useParams hook（直接代理到 react-router） */
    useParams = useParams;
    /** useNavigate hook（直接代理到 react-router） */
    useNavigate = useNavigate;
    /** useLocation hook（适配为统一的 IRouteLocation） */
    useLocation = () => {
        const location = useLocation();
        return {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash,
        };
    };
    /** useSearchParams hook（直接代理到 react-router） */
    useSearchParams = useSearchParams;
    /** 后退（基于 useNavigate 的封装） */
    goBack = () => {
        // 注意：此方法需要在 React 组件上下文之外调用，
        // 仅作为 API 占位。实际后退请使用 useNavigate()(-1)。
        console.warn('[RouteService] goBack() is a placeholder. Use useNavigate()(-1) in components.');
    };
    /** 导航到指定路径（非 Hook 版本） */
    navigate = (to, _options) => {
        // 注意：此方法需要在 React 组件上下文之外调用，
        // 仅作为 API 占位。实际导航请使用 useNavigate()(to)。
        console.warn('[RouteService] navigate() is a placeholder. Use useNavigate()(to) in components.');
    };
}
//# sourceMappingURL=route-service.js.map